import { Component } from '@angular/core';

@Component({
    selector: 'app-terms-of-service',
    templateUrl: './terms-of-service.component.html',
    styleUrls: ['../privacy-policy/privacy-policy.component.scss'],
    standalone: false
})
export class TermsOfServiceComponent {}
